import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../config";
import Navbar from "../../components/Navbar/Navbar";

export default function ArPendencia() {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15); // Define quantos itens por página
    const [searchTerm, setSearchTerm] = useState('');

    // Mapeamento de status
    const statusMap = {
        1: 'Despacho Notificação',
        2: 'Relatório',
        3: 'Análise Técnica',
        4: 'Solicitado Documentação',
        5: 'Análise Documental',
        6: 'Análise Encerramento',
        7: 'Deferido',
        8: 'Indeferido',
        9: 'Arquivado',
    };

    // Função para calcular o tempo decorrido
    const calculateElapsedTime = (dateString) => {
        const parsedDate = parseDate(dateString);
        const currentDate = new Date();
        const timeDiff = Math.abs(currentDate - parsedDate);
        const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Converte milissegundos em dias
        return diffDays;
    };

    // Função para definir a cor com base no número de dias
    const getElapsedTimeClass = (days) => {
        return days <= 15 ? 'yellow-bg' : 'red-bg'; // <= 15 dias: amarelo, > 15 dias: vermelho
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/ar/pendentes`);
                if (!response.ok) {
                    throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
                }
                const result = await response.json();

                // Ordenar os dados por 'dataMovimentacao' em ordem crescente (mais antigo para o mais recente)
                result.sort((a, b) => parseDate(a.dataMovimentacao) - parseDate(b.dataMovimentacao));
                setData(result);
            } catch (error) {
                console.error('Erro ao buscar dados:', error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);


    const parseDate = (dateString) => {
        if (!dateString) return new Date(); // Evita erro com datas indefinidas ou nulas
        const [day, month, year] = dateString.split('/').map(Number);
        return new Date(year, month - 1, day);
    };

    // Filtragem dos dados
    const filteredData = data.filter(item => {
        return item.processo ? item.processo.toString().includes(searchTerm) : false;
    });

    // Ordenação dos dados filtrados
    const sortedData = [...filteredData].sort((a, b) => {
        if (sortConfig.key === 'dataMovimentacao') {
            const dateA = parseDate(a.dataMovimentacao);
            const dateB = parseDate(b.dataMovimentacao);
            return sortConfig.direction === 'ascending' ? dateA - dateB : dateB - dateA;
        } else {
            if (a[sortConfig.key] && b[sortConfig.key]) {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
            }
            return 0;
        }
    });

    // Paginação nos dados ordenados e filtrados
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(sortedData.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const getSortDirectionIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? '↑' : '↓';
        }
        return '';
    };

    const getStatusBorderClass = (status) => {
        const statusText = statusMap[status];
        switch (statusText) {
            case 'Despacho Notificação':
                return 'borda-verde-escuro';
            case 'Relatório':
                return 'borda-verde-claro';
            case 'Análise Técnica':
                return 'borda-azul-claro';
            case 'Análise Documental':
                return 'borda-azul-escuro';
            case 'Análise Encerramento':
                return 'borda-roxo';
            case 'Solicitado Documentação':
                return 'borda-vermelho';
            case 'Deferido':
            case 'Indeferido':
            case 'Arquivado':
                return ''; // Sem borda, ou defina a borda que deseja aqui
            default:
                return ''; // Sem borda por padrão
        }
    };

    return (
        <div className="home">
            <Navbar searchTerm={searchTerm} onSearchChange={setSearchTerm} />
            <div className="table-container">
                {loading ? (
                    <p>Carregando...</p>
                ) : (
                    <>
                        <table className="data-table">
                            <thead>
                            <tr>
                                <th>Ordem</th>
                                <th>Processo</th>
                                <th>Data da Movimentação</th>
                                <th>Tempo decorrido</th>
                                <th>Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            {currentItems.length > 0 ? (
                                currentItems.map((item, index) => {
                                    const elapsedTime = calculateElapsedTime(item.dataMovimentacao);
                                    return (
                                        <tr key={item.id_ac_atendimento}>
                                            <td data-label="Ordem">{indexOfFirstItem + index + 1}</td>
                                            <td data-label="Processo">{item.processo}</td>
                                            <td data-label="Data da Movimentação">{item.dataMovimentacao}</td>
                                            <td data-label="Tempo decorrido">
                                                <div className={getElapsedTimeClass(elapsedTime)}>
                                                    {/* Exibe o tempo decorrido calculado */}
                                                    {elapsedTime} dias
                                                </div>
                                            </td>
                                            <td data-label="Status">
                                                <div className={getStatusBorderClass(item.status)}>
                                                    {statusMap[item.status] || 'Status desconhecido'}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="7">Nenhum credenciamento encontrado!</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                        <div className="pagination">
                            <button
                                onClick={prevPage}
                                className="page-button"
                                disabled={currentPage === 1}
                            >
                                Anterior
                            </button>
                            {Array.from({ length: totalPages }, (_, i) => (
                                <button
                                    key={i + 1}
                                    onClick={() => paginate(i + 1)}
                                    className={`page-button ${currentPage === i + 1 ? 'active' : ''}`}
                                >
                                    {i + 1}
                                </button>
                            ))}
                            <button
                                onClick={nextPage}
                                className="page-button"
                                disabled={currentPage === totalPages}
                            >
                                Próxima
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
